
// 全局属性和方法
export default {
    methods: {
        _dynamicFun (script, model) {
            if (!script) return false
            const func = script.indexOf('return') >= 0 ? '{' + script + '}' : 'return (' + script + ')'
            const Fn = new Function('$', func)
            return Fn(model)
        }
    }
}
